import { render, staticRenderFns } from "./addchangqi.vue?vue&type=template&id=8a7f494e&scoped=true&"
import script from "./addchangqi.vue?vue&type=script&lang=js&"
export * from "./addchangqi.vue?vue&type=script&lang=js&"
import style0 from "./addchangqi.vue?vue&type=style&index=0&id=8a7f494e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f494e",
  null
  
)

export default component.exports